<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Smart Irrigation</a></li>
      <li class="breadcrumb-item active"><strong>System Health</strong></li>
    </ol>
  </div>
  <div class="col-lg-2 d-flex align-items-center justify-content-end gap-2">
    <small class="text-muted" *ngIf="lastRefresh">{{ lastRefresh | date:'d MMM yyyy HH:mm' }}</small>
    <button class="btn btn-outline-white btn-sm" (click)="refresh()" [disabled]="loading" title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="loading"></i>
    </button>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">
  <div class="alert alert-info" *ngIf="loading">
    <i class="fa fa-spinner fa-spin me-2"></i> Loading device health&hellip;
  </div>

  <ng-container *ngIf="!loading">
    <div class="alert alert-secondary" *ngIf="rows.length === 0">
      No devices found across the Smart Irrigation node structure.
    </div>

    <ng-container *ngIf="rows.length > 0">
      <div class="sh-summary-card">
        <div class="sh-summary-card__chart">
          <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="pieChartOptions" style="width:100%;height:260px;display:block;"></highcharts-chart>
        </div>
        <div class="sh-summary-card__stats">
          <div class="sh-stat sh-stat--ok">
            <span class="sh-stat__dot"></span>
            <span class="sh-stat__label">Up to date</span>
            <strong class="sh-stat__value">{{ okCount }}</strong>
          </div>
          <div class="sh-stat sh-stat--overdue">
            <span class="sh-stat__dot"></span>
            <span class="sh-stat__label">Overdue (&gt; 4 hours)</span>
            <strong class="sh-stat__value">{{ overdueCount }}</strong>
          </div>
        </div>
      </div>

      <div class="sh-table-card">
        <table class="sh-table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Park</th>
              <th>Device</th>
              <th>Type</th>
              <th>Last Seen</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows">
              <td>
                <span class="sh-light" [ngClass]="'sh-light--' + row.status" [title]="row.status === 'ok' ? 'Up to date' : 'Overdue'"></span>
              </td>
              <td>{{ row.parkName }}</td>
              <td>{{ row.deviceName }}</td>
              <td>{{ row.deviceType }}</td>
              <td>{{ row.lastSeen | relativeDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-container>
</div>
